module.exports = __webpack_public_path__ + "assets/images/cliente_9ac397a8094927b08922ae3a3a1ae3fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/level-bar/cliente.png
// module id = 244
// module chunks = 0